<template>
    <div class="c-notifications" ref="notificationsPanel"
        :data-component-name="$options.name"
    >
        <v-idle
            :events="['mousemove', 'scroll', 'keyup']"
            :duration="1800"
            @idle="appIdle=true"
            @active="setActive()"
        />
        <!-- {{ appIdle }} -->
        <div class="c-notifications-header">
            <div class="c-notifications-toggles__wrap">
                <div
                    class="c-notifications-toggles__item"
                    :class="{
                        'is-selected' : currentTab=='internal_notes',
                    }"
                    @click="setCurrentTab('internal_notes')"
                    v-if="!globalPanel"
                >
                    <q-icon name="description" size="14px" v-if="compactPanel || compactPanelNotes"  title="Notes internes" />
                    <span v-else class="text-no-wrap">
                        Notes internes
                    </span>
                    <span class="o-count" v-if="parentProject && parentProject.internal_notes && parentProject.internal_notes!='' && parentProject.internal_notes!='<br>'"><span>1</span></span>
                </div>
                <div
                    class="c-notifications-toggles__item"
                    :class="{
                        'is-selected' : currentTab=='inbox',
                    }"
                    @click="setCurrentTab('inbox')"
                >
                    <q-icon name="move_to_inbox" size="14px" v-if="compactPanel" title="Messages" />
                    <span v-else>
                        Messages
                    </span>
                    <span class="o-count" v-if="unreadMessagesCount>0"><span>{{ unreadMessagesCount }}</span></span>
                </div>
                <!-- <div
                    class="c-notifications-toggles__item"
                    :class="{
                        'is-selected' : currentTab=='sent',
                    }"
                    @click="setCurrentTab('sent')"
                >
                    <q-icon name="outbox" size="14px" v-if="compactPanel" title="Messages envoyés" />
                    <span v-else>
                        Envoyés
                    </span>
                </div> -->
                <div
                    class="c-notifications-toggles__item"
                    :class="{
                        'is-selected' : currentTab=='errors',
                    }"
                    @click="setCurrentTab('errors')"
                    v-if="myUserProfile.role=='ADMINISTRATOR'"
                >
                    <q-icon name="bug_report" size="14px" v-if="compactPanel" title="Erreurs" />
                    <span v-else>
                        Erreurs
                    </span>
                    <span class="o-count -errors" v-if="unreadErrorsCount>0"><span>{{ unreadErrorsCount }}</span></span>                </div>
                <div
                    class="c-notifications-toggles__item"
                    :class="{
                        'is-selected' : currentTab=='history',
                    }"
                    @click="setCurrentTab('history')"
                    v-if="!globalPanel"
                >
                    <q-icon name="history" size="14px" v-if="compactPanel" title="Historique" />
                    <span v-else>
                        Historique
                    </span>
                </div>
            </div>
        </div>
        

        <div v-if="currentTab=='internal_notes' && projectID && !globalPanel" class="flex flex-grow">
            <ProjectInternalNotes
                :projectID="projectID"
            />
        </div>

        <NotificationsV2
            :isMobile="true"
            :inPage="false"
            @set-current-date="$emit('set-current-date', $event)"
            v-if="currentTab=='inbox'"
            :projectID="projectID"
        />


        <div class="c-notifications-subheader -hidden-mobile"
            v-else-if="notificationsList && !notificationsList.loading && !loading && notificationsList.data && currentTab!='history'"
        >
            <div v-if="currentTab!='history'" class="row full-width align-content-center">
                <div v-if="currentTab=='inbox' || currentTab=='sent'">
                    <q-checkbox dense :label="selectAllLabel" v-model="selectAll" size="24px" color="blue"
                        :class="{'is-indeterminate': selectAll===null}"
                    />
                </div>
                <div>
                    <q-btn 
                        name="deleteSelected" 
                        label="Supprimer" 
                        color="white" 
                        text-color="primary"
                        icon-right="o_delete"
                        size="7px"
                        no-caps
                        rounded
                        outline
                        class="-buttons q-ml-sm"
                        v-if="selected.length>0"
                        @click.stop="deleteNotification(null)"
                    />
                </div>
                <div class="o-spacer"></div>
                <div v-if="currentTab=='inbox' || currentTab=='errors'">
                    <q-select
                        v-model="filterModel"
                        name="filter"
                        title="Filtrer"
                        bg-color="primary" 
                        size="sm"
                        no-caps
                        rounded borderless
                        dense
                        class="-buttons -filter-select q-ml-sm on-right"
                        popup-content-class="-notifications-filter-select-popup"
                        :options="filterOptions"
                    />
                </div>
                
                <div v-if="currentTab=='inbox'">
                    <q-btn 
                        name="newMessage" 
                        color="green"
                        text-color="white"
                        icon="add"
                        size="7px"
                        no-caps
                        rounded
                        title="Nouveau message"
                        class="-buttons -only-icon q-ml-sm"
                        @click.stop="newMessage()"
                    />
                </div>

            </div>
        </div>
        <div class="c-notifications-subheader hidden"
            v-else-if="(!notificationsList || (notificationsList && notificationsList.loading) || loading) && (currentTab!='history'  && currentTab!='inbox')"
        >
            <div>
                <q-spinner
                    color="primary"
                    size="1em"
                    class="q-mr-xs"
                />
                Chargement en cours
            </div>
        </div>
        <div v-if="currentTab!='inbox'" class="c-notifications-row -list-header  -hidden-mobile">
            <div class="c-notifications-content">
                <div class="c-notifications-checkbox" v-if="currentTab=='sent'">
                    À
                </div>
                <div class="c-notifications-checkbox" v-else>
                    De
                </div>
                <div class="c-notifications-avatar">
                </div>
                <div class="-from">
                </div>
                <div class="-subject">
                    Sujet
                </div>
                <div class="-date">
                    Reçu
                </div>
                <div class="c-notifications-controls">
                </div>
            </div>
        </div>

        <!-- <div class="c-notifications-row no-notifs">
            <pre> {{ notifications }} </pre>
        </div> -->

        <!-- <div class="c-notifications-row__wrap">
            <pre>{{ this.notificationsList }}</pre>
        </div> -->

        <div class="c-notifications-row no-notifs"
            v-if="notificationsList && !notificationsList.loading && notificationsList.data && notificationsList.data.length==0 && (currentTab!='internal_notes' && currentTab!='inbox')"
        >
            Aucun message à afficher
        </div>


        <div class="c-notifications-row__wrap -snap-enable"
            v-else-if="notificationsList && currentTabLoaded && currentTab!='inbox'"
            ref="js-notifications-list"
            id="js-notifications-list"
            @scroll.passive="onNotificationsScroll()"
        >
            <Notification 
                :isMobile="isMobile"
                :inPage="inPage"
                :key="notification.id"
                :currentTab="currentTab"
                :parentNotification="notification"
                :projectID="projectID"
                :deletedNotifications="deletedNotifications"
                :selected="selected"
                v-for="(notification) in notificationsList.data"
                class="c-notifications-row -scrollable"
                @set-selected="setSelected(notification.id)"
                @delete-notification="deleteNotification(notification)"
                @notification-scroll="onNotificationsScroll()"
            />

            <div class="c-notifications-row -loading" v-if="notificationsList.paginatorInfo && notificationsList.paginatorInfo.hasMorePages">
                <div v-if="!loading" ref="js-notifications-actions" @click="onNotificationsScroll()">Plus de résultats...</div>
                <div v-else>
                    <q-spinner
                        color="primary"
                        size="1em"
                        class="q-mr-xs"
                    />
                    Chargement en cours...
                </div>
            </div>

            <div class="c-notifications-row -spacer">
            </div>

        </div>





        <q-dialog v-model="showMessageModal"
            ref="messageDialog"
        >
            <q-card class="c-message-dialog" v-if="showMessageModal">
                <q-card-section class="c-message-dialog-header">
                    <h2>{{ messageModel.title }}</h2>
                </q-card-section>

                <div class="o-row">
                    <div class="o-value o-row flex-nowrap">
                        <div class="o-label text-no-wrap">
                            À :
                        </div>
                        <div class="o-value q-mb-none">
                            <UserProfileInput
                                v-model="messageModel.to"
                                :filled="false"
                                :flat="true"
                                :required="true"
                                :userGroups="messageModel.userGroups"
                                class="o-qinput q-mb-none"
                                :multiple="true"
                                :disable="messageModel.isReply"
                                :readonly="messageModel.isReply"
                                use-chips
                            />
                        </div>
                    </div>
                    <div class="flex-break"></div>
                    <div  class="o-label text-no-wrap">
                        Sujet :
                    </div>
                    <div class="o-value">
                        <Input
                            input-class="o-qinput"
                            :filled="false"
                            :flat="true"
                            v-model="messageModel.subject"
                            :required="true"
                            :disable="messageModel.isReply"
                            :readonly="messageModel.isReply"
                        />
                    </div>
                    <div class="flex-break"></div>
                    <div class="o-value o-row flex-nowrap">
                        <div  class="o-label -dense text-no-wrap">
                            Message :
                        </div>
                        <div class="o-value">
                            <q-editor ref="messageDialogContentEditable" v-model="messageModel.message" min-height="5rem" style="min-height: 20vh; max-height: 40vh;"
                                :autogrow="false"
                                class=""
                                :toolbar="[
                                    ['bold', 'italic', 'strike', 'underline'],
                                ]"
                            />
                        </div>
                    </div>
                </div>

                <q-card-actions align="right">
                    <q-btn class="o-button -md" icon-right="close" no-caps rounded outline color="primary" label="Annuler" v-close-popup />
                    <q-btn class="o-button -md" icon-right="o_mail" no-caps rounded label="Répondre" color="primary" v-if="messageModel.isReply" @click.stop="sendReply(messageModel)"  />
                    <q-btn class="o-button -md" icon-right="o_mail" no-caps rounded label="Envoyer" color="primary" v-else @click.stop="sendMessage(messageModel)"  />
                </q-card-actions>

            </q-card>
        </q-dialog>
    </div>
</template>

<script>
    import { HISTORY } from "@/graphql/history/queries";
    import { INBOX/*, NOTIFICATIONSCOUNT/*, PROJECTSINBOX*/ } from "@/graphql/notification/queries";
    import { /*MARKASREAD,*/ DELETENOTIFICATIONS,/* REPLYNOTIFICATION,*/ SENDMESSAGE } from "@/graphql/notification/mutations"
    // import { MYPROFILE } from '@/graphql/user/queries'
    // import { isJson } from "@/js/utilities";
    import { relativeDate/*, dayOfWeekStr, dayStr, monthStr*/ } from "@/js/dateUtilities";
    import uniqBy from 'lodash/uniqBy'
    // import moment from 'moment';
    import Notification from '@/components/notifications/Notification'
    import ProjectInternalNotes from '@/components/projects/ProjectInternalNotes.vue'
    import NotificationsV2 from '@/components/notifications/NotificationsV2'


    export default {
        name: 'Notifications',
        components: {
            Notification,
            NotificationsV2,
            ProjectInternalNotes
        },
        props: {
            projectID: {
                type: [Number, String],
                default: null
            },
            parentProject: {
                type: Object,
                default: null
            },
            userProfileIDprop: {
                type: Number,
                default: null
            },
            globalPanel: {
                type: Boolean,
                default: false
            },
            inPage: {
                type: Boolean,
                default: false
            },
            initialTab: {
                type: String,
                default: null
            },
            isMobile: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                myUserProfileID: window.myUserProfileID,
                myUserProfile: window.myUserProfile,
                selectAll: null,
                checkBox: [],
                selected: [],
                appName: process.env.VUE_APP_NAME,
                currentTab: null,
                queryResult: 'inbox',
                queryResultVariables: null,
                expanded: {
                    inbox: [],
                    history: [],
                    error: []
                },
                showMessageModal: false,
                messageModel: {
                    title: null,
                    to: null,
                    subject: null,
                    message: null,
                    notificationID: null,
                    isReply: false,
                    userGroups: []
                },
                autoRefreshTO:{},
                eventbusRefreshTO:{},
                // autoRefreshInterval: 10000,
                autoRefreshInterval: 120000,
                loading: true,
                skipQueriesStart: true,
                notificationScrollTo: null,
                notificationCountTo: null,
                notificationsList: {},
                deletedNotifications: {},
                pagedNotifications: {},
                unreadMessagesCount: 0,
                unreadErrorsCount: 0,
                watcher: Date.now(),
                pageSize: 15,
                isLoadingMore: false,
                currentTabLoaded: false,
                filterOptions: [
                    {
                        label: "Tout",
                        value: null
                    },
                    {
                        label: "Non lus",
                        value: 'unread'
                    },
                    {
                        label: "Lus",
                        value: 'read'
                    },
                ],
                filterModel: {label: "Tout", value: null},
                replyInput: {},
                selectAllLabel: 'Sélectionner tout',
                appIdle: false,
                compactPanel: false,
                compactPanelNotes: false
            }
        },
        mounted(){
            if(this.initialTab) this.currentTab=this.initialTab;
            if(!this.initialTab) this.currentTab='inbox';

            this.isCompactPanel();

            this.$eventBus.$on('refresh-notifications', function(event){
                if(this.projectID && event!=this.projectID) return;

                clearTimeout(this.eventbusRefreshTO);
                this.eventbusRefreshTO=setTimeout(function(){
                    this.setAutoRefresh();
                    this.refreshList();
                }.bind(this), 5000)
            }.bind(this))
            this.setUserGroups();

            if(!this.projectID) this.unreadMessagesCount=window.unreadMessagesCount
            if(!this.projectID) this.unreadErrorsCount=window.unreadErrorsCount
            if(this.projectID) this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )

            this.$eventBus.$on('set-notifs-count', function(e){
                if(this.projectID && e.projectID==this.projectID){
                    this.unreadMessagesCount=e.unreadProjectMessages
                    this.unreadErrorsCount=e.unreadProjectErrors
                }else if(!this.projectID){
                    this.unreadMessagesCount=e.unreadMessagesCount
                    this.unreadErrorsCount=e.unreadErrorsCount
                }
            }.bind(this))

            if(!this.globalPanel) window.addEventListener("resize", this.isCompactPanel);


        },
        beforeDestroy() {
            this.$eventBus.$off('refresh-notifications');
            if(!this.globalPanel) window.removeEventListener("resize", this.isCompactPanel);

            // this.$eventBus.$off('set-notifs-count');
            clearTimeout(this.autoRefreshTO);
            clearTimeout(this.eventbusRefreshTO);
            // this.$eventBus.$off('set-notifs-count');
        },
        watch: {
            initialTab: function(){
                this.currentTab=this.initialTab;
            },
            parentProject: function(){
                this.setUserGroups();
            },
            messageModel: function(){
                this.messageModel.to=uniqBy(this.messageModel.to, 'id');
            },
            filterModel: function(){
                if(this.filterModel.value=="unread"){
                    // this.queryResultVariables.unread=true;
                    this.$set(this.queryResultVariables, "unread", true)

                    return;
                }else if(this.filterModel.value=="read"){
                    this.queryResultVariables.unread=false;
                    return;
                }
                this.queryResultVariables.unread=null;
                delete this.queryResultVariables.unread
            },
            selected: function(){
                this.selectAllLabel="Sélectionner tout";
                if(!this.notificationsList?.data) return this.selectAll=false;
                let unselected=this.notificationsList.data.filter(obj => !this.selected.includes(obj.id))
                if(unselected.length>0 && this.selected.length>0) return this.selectAll=null;
                if(this.notificationsList?.data.length==0 || this.selected.length==0) return this.selectAll=false;
                if(unselected.length==0){
                    this.selectAllLabel="Désélectionner tout";
                    return this.selectAll=true;
                }
            },
            selectAll: function(){
                if(this.selectAll===false) this.selected=[];
                if(this.selectAll){
                    this.selected=[];
                    this.notificationsList.data.forEach(function(item){
                        this.selected.push(item.id)
                    }.bind(this))
                }
            },
            currentTab: function(){
                this.skipQueriesStart=true;

                if(this.notifications?.data) this.currentTabLoaded=false;

                this.filterModel={label: "Tout", value: null}
                if(this.currentTab=="history"){
                    this.$apollo.queries.notifications.options.query= HISTORY
                    this.queryResult="history"
                    this.queryResultVariables={};
                }

                if(this.currentTab=="errors"){
                    this.$apollo.queries.notifications.options.query= INBOX
                    this.queryResult="inbox"
                    // console.log(this.queryResultVariables);
                    this.queryResultVariables={
                        type: ["ALERT", "ASSIGNMENTCONFLICT", "ABSENCECONFLICT"],
                        upcomingAssignmentErrors: this.projectID==null
                    };
                }

                if(this.currentTab=="inbox"){
                    // console.log('ici')
                    this.$apollo.queries.notifications.options.query= INBOX
                    this.queryResult="inbox"
                    this.queryResultVariables={type: ["REPLY", "INFO"]};
                }

                if(this.currentTab=="sent"){
                    this.$apollo.queries.notifications.options.query= INBOX
                    this.queryResult="inbox"
                    this.queryResultVariables={type: ["SENT"]};
                }

                if(this.currentTab!="internal_notes" && this.currentTab!="inbox"){

                    this.selected=[];
                    this.deletedNotifications[this.currentTab]=[];
                    clearTimeout(this.eventbusRefreshTO);
                    this.pagedNotifications={};
                    this.notificationsList={};
                    this.setAutoRefresh();
                    if(this.projectID) this.queryResultVariables.projectID=this.projectID
                    this.skipQueriesStart=false;
                }
                return;
            },
            watcher: function(){
                let tmpList={};

                Object.keys(this.pagedNotifications).forEach(function(page){
                    if(!tmpList.data) tmpList.data=[];
                    if(this.pagedNotifications[page]?.data.length>0){
                        tmpList={
                            __typename: this.pagedNotifications[page].__typename,
                            data: [...tmpList.data, ...this.pagedNotifications[page].data],
                            paginatorInfo: this.pagedNotifications[page].paginatorInfo
                        }
                    }
                }.bind(this))

                tmpList.data=uniqBy(tmpList.data, 'id');
                let notificationsIDs=[];
                tmpList.data.forEach(function(item, index){
                    this.checkBox[index]=false;
                    notificationsIDs.push(item.id)

                    if (this.currentTab == "errors") {
                        if (!item.created_by) item.created_by = {};
                        item.created_by.name=this.appName;
                    }
                }.bind(this))
                if(tmpList.paginatorInfo) tmpList.paginatorInfo.currentPage=Math.ceil(tmpList.data.length/this.pageSize)
                this.notificationsList=tmpList;

                this.selected=this.selected.filter(obj => notificationsIDs.includes(obj))
                this.setAutoRefresh();
                this.onNotificationsScroll();
            },
        },
        methods: {
            isCompactPanel(){
                let clientWidth=null
                if(this.$refs.notificationsPanel) clientWidth=this.$refs.notificationsPanel.clientWidth;

                this.compactPanelNotes=false;
                this.compactPanel=false;

                if(clientWidth && clientWidth<400){
                    this.compactPanelNotes=true;
                    this.compactPanel=false;
                }
                
                if(clientWidth && clientWidth<340){
                    this.compactPanelNotes=false;
                    this.compactPanel=true;
                }
            },
            setUserGroups(){
                this.messageModel.userGroups=[];
                if(this.parentProject?.projectShifts){
                    let assigned=[];
                    this.parentProject.projectShifts.forEach(function(projectShift){
                        projectShift.projectAssignments.forEach(function(assignment){
                            if(assignment.assignedTo) assigned.push(assignment.assignedTo)
                        })
                    })

                    if(assigned.length>0) this.messageModel.userGroups.push({
                        'label': "Tous les employés assignés (" + assigned.length +")",
                        'values': assigned
                    })
                }
                if(this.parentProject?.projectManager){
                    this.messageModel.userGroups.push({
                        'label': "Chargé de projet (" + this.parentProject.projectManager.name + ")",
                        'values': [this.parentProject.projectManager]
                    })
                }
                if(this.parentProject?.supervisor){
                    this.messageModel.userGroups.push({
                        'label': "Superviseur de travaux : " + this.parentProject.supervisor.name,
                        'values': [this.parentProject.supervisor]
                    })
                }
            },
            setCurrentTab(tab){
                if(this.currentTab==tab) this.refreshList();
                this.currentTab=tab;
            },
            setSelected(notificationID){
                if(this.selected.includes(notificationID)){
                    this.selected=this.selected.filter(obj => obj != notificationID)
                }else{
                    this.selected.push(notificationID)
                }
            },
            setAutoRefresh(){
                clearTimeout(this.autoRefreshTO);
                this.autoRefreshTO=setTimeout(function(){
                    this.refreshList();
                    this.setAutoRefresh();
                }.bind(this), this.autoRefreshInterval)
            },
            refreshList(){
                this.isLoadingMore=false;
                if(!this.appIdle) this.$apollo.queries.notifications.refetch();
                this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
            },
            setActive(){
                if(!this.appIdle) return;
                this.appIdle=false;
                this.refreshList()
            },
            onNotificationsScroll(){
                if(!this.notificationsList?.paginatorInfo?.hasMorePages) return;
                this.notificationScrollTo=setTimeout(function(){
                    var loadMoreEl = this.$refs["js-notifications-actions"];
                    var loadMoreParent = this.$refs["js-notifications-list"];
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = loadMoreParent.getBoundingClientRect().height+loadMoreParent.getBoundingClientRect().top;
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreNotifications();
                        }
                    }
                }.bind(this), 300);
            },
            getMoreNotifications(loadPage=null){
                let page=this.notificationsList.paginatorInfo.currentPage+1;
                if(loadPage) page=loadPage;
                this.isLoadingMore=true
                this.$apollo.queries.notifications.fetchMore({
                    variables: {
                        page: page,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        this.isLoadingMore=true
                        let page=fetchMoreResult[this.queryResult].paginatorInfo.currentPage
                        if(!this.pagedNotifications[page]) this.pagedNotifications[page]={};

                        if(fetchMoreResult[this.queryResult].data.length==0){
                            delete this.pagedNotifications[page]
                            this.notificationsList.hasMorePages=false;
                        }else{
                            this.pagedNotifications[page]=JSON.parse(JSON.stringify(fetchMoreResult[this.queryResult]))
                        }
                        this.watcher=Date.now();

                        let data = {}
                        data[this.queryResult]={
                            __typename: previousResult[this.queryResult].__typename,
                            data: [...previousResult[this.queryResult].data, ...fetchMoreResult[this.queryResult].data],
                            paginatorInfo: fetchMoreResult[this.queryResult].paginatorInfo
                        }
                        this.setAutoRefresh()
                        return data
                    },
                })
            },
            getRelativeDate(date){
                return relativeDate(date);
            },
            deleteNotification(item=null){
                let pages=[];
                let itemIDs=[];

                if(item) itemIDs.push(item.id)
                if(!item) itemIDs=this.selected;

                this.deletedNotifications[this.currentTab]=[...this.deletedNotifications[this.currentTab], ...itemIDs]


                this.$apollo.mutate({
                    mutation: DELETENOTIFICATIONS,
                    variables: {
                        id: itemIDs
                    },
                    update: (store, { data: { deleteNotifications } }) => {
                        deleteNotifications.forEach(function(deleteNotification){
                            Object.keys(this.pagedNotifications).forEach(function(page){
                                let result=this.pagedNotifications[page].data.filter(obj => obj.id === deleteNotification.id)
                                if(result && !pages.includes(page))  pages.push(page)
                            }.bind(this))
                        }.bind(this))

                        if(pages.length>0){
                            pages.sort();
                            pages.forEach(function(page){
                                this.getMoreNotifications(page);
                            }.bind(this))
                        }
                    }
                })
                .then(function(){
                    this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
                }.bind(this)).catch(() => {})
            },
            replyTo(notification){
                let messageModel=this.messageModel;

                messageModel.title="Répondre";
                notification.created_by.label=notification.created_by.name;
                messageModel.to=[notification.created_by];
                messageModel.subject=notification.subject;
                if(notification.subject.substring(0,3)!='Re:'){
                    messageModel.subject='Re: '+notification.subject;
                }
                messageModel.message='';
                messageModel.notificationID=notification.id;
                messageModel.isReply=true;
                this.showMessageModal=true;
                setTimeout(function(){
                    this.$refs.messageDialogContentEditable.focus();
                }.bind(this), 500)
            },
            newMessage(){
                let messageModel=this.messageModel;
                messageModel.title="Nouveau message";
                messageModel.to=null;
                messageModel.subject="";
                messageModel.message='';
                messageModel.notificationID=null
                messageModel.projectID=this.projectID;
                messageModel.isReply=false;
                this.showMessageModal=true;
                setTimeout(function(){
                    this.$refs.messageDialogContentEditable.focus();
                }.bind(this), 500)
            },
            sendMessage(messageModel){
                let message = {
                    subject: messageModel.subject,
                    message: messageModel.message,
                    projectID: messageModel.projectID,
                    assignmentID: messageModel.assignmentID,
                    projectShiftID: messageModel.projectShiftID,
                    shiftID: messageModel.shiftID,
                    to: []
                }
                messageModel.to.forEach(function(item){
                    message.to.push(item.id);
                })
                this.$apollo.mutate({
                    mutation: SENDMESSAGE,
                    variables: {
                        ...message
                    }
                }).then(function(){
                    this.$refs.messageDialog.hide();
                    this.setAutoRefresh()
                    this.refreshList();
                }.bind(this))
            },
            replyOnEnter(event/*, message, notificationID, index*/){
                if(event.code=="Enter" && !event.shiftKey){
                    event.stopPropagation();
                }
            },
        },
        apollo: {
            notifications: {
                query: INBOX,
                fetchPolicy: 'network-only',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                // debounce: 200,
                skip(){
                    return this.skipQueriesStart
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                variables() {
                    return {
                        page: 0,
                        first: this.pageSize,
                        // userProfileID: this.userProfileID,
                        ...this.queryResultVariables,
                        args: {
                            projectID: this.projectID,   
                        }
                    }
                },
                update(data) {
                    if(!this.isLoadingMore){
                        let currentPage=1
                        
                        if(this.notificationsList?.paginatorInfo) currentPage=JSON.parse(JSON.stringify(this.notificationsList?.paginatorInfo?.currentPage));

                        if(data[this.queryResult].paginatorInfo.currentPage==1){
                            if(!this.pagedNotifications[1]) this.pagedNotifications[1]={};
                            this.pagedNotifications[1]=data[this.queryResult]
                        }
                        
                        if(currentPage>data[this.queryResult].paginatorInfo.currentPage && data[this.queryResult].paginatorInfo.currentPage==1){
                            for(let i=2; i<=currentPage; i++){
                                this.$nextTick(function(){
                                    this.getMoreNotifications(i);
                                }.bind(this))
                            }
                        }

                        this.watcher=Date.now();
                        this.currentTabLoaded=true;
                        // this.$eventBus.$emit('refresh-myProfile');
                        // this.$apollo.queries.myProfile.refetch();
                    }
                    this.isLoadingMore=false;
                    return data[this.queryResult]
                },
            }
        }
    }
</script>
<style lang="scss">
    @import "@/scss/components/notifications/Notifications2.scss";
</style>